
import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

interface SignUpHeaderProps {
  step: 'user' | 'card' | 'signin' | 'bitcoin';
}

const SignUpHeader: React.FC<SignUpHeaderProps> = ({ step }) => {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      <div className="flex justify-center mb-4">
        <Shield className="h-12 w-12 text-white" />
      </div>
      
      {/* Brand header with Bluetooth$ */}
      <div className="text-center mb-6">
        <h1 className="text-5xl font-bold text-white mb-4">
          Bluetooth$
        </h1>
        <p className="text-xl text-white/80 max-w-md mx-auto">
          Send Money Anywhere, Anytime with AI Security At Your Fingertips
        </p>
      </div>

      <h2 className="mt-6 text-center text-3xl font-bold text-white">
        {step === 'user' ? 'Create your account' : 
         step === 'signin' ? 'Sign in to continue' : 
         step === 'bitcoin' ? 'Verify Bitcoin address' :
         'Verify payment method'}
      </h2>
      <p className="mt-2 text-center text-sm text-white/80">
        Already have an account?{' '}
        <Link to="/signin" className="font-medium text-white underline hover:text-blue-200">
          Sign in
        </Link>
      </p>
    </div>
  );
};

export default SignUpHeader;
